export * from '@fhs/routing/src/routes/(tabs)/_layout';
export { default } from '@fhs/routing/src/routes/(tabs)/_layout';
